import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { Container, Grid, TAGTypography, useTheme } from '../../';
import TermsAndConditions from './TermsAndConditions';
import { ASPENDENTAL_FONTS } from '../../constants/constant';
import { FacilityContext } from '../../contexts';

var Pricing = function Pricing(_ref) {
  var _facilityState$servic;

  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'light' : _ref$backgroundColor,
      branding = _ref.branding,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      price = _ref.price,
      procedureCode = _ref.procedureCode,
      tc = _ref.tc,
      title = _ref.title;

  var _useContext = useContext(FacilityContext),
      facilityState = _useContext.state;

  var isDark = backgroundColor === 'dark';
  var theme = useTheme();
  var serviceObj = facilityState === null || facilityState === void 0 ? void 0 : (_facilityState$servic = facilityState.services) === null || _facilityState$servic === void 0 ? void 0 : _facilityState$servic.find(function (n) {
    return n.procedureCode === procedureCode;
  });
  return React.createElement(Grid, {
    sx: fullWidth ? {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      padding: '40px 0'
    } : {
      padding: '40px 0'
    }
  }, React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    })
  }, React.createElement(Grid, {
    container: true,
    sx: {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      padding: '28px 0',
      borderRadius: {
        md: '6px',
        lg: '6px',
        sm: 0,
        xs: 0
      },
      backgroundColor: fullWidth ? 'transparent' : "backgrounds.".concat(backgroundColor),
      '& .MuiStepper-horizontal': {
        display: {
          xs: 'none',
          sm: 'none',
          md: 'none',
          lg: 'none'
        }
      },
      'div:last-child': {
        textAlign: 'center'
      },
      '.card-content': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: {
          md: 'row',
          lg: 'row',
          sm: 'row',
          xs: 'column'
        },
        gap: {
          md: '16px',
          lg: '16px',
          sm: '16px',
          xs: '32px'
        },
        margin: 'auto',
        width: {
          md: '70%',
          lg: '50%',
          sm: '60%',
          xs: '90%'
        }
      },
      '.card-content p': {
        margin: '0px'
      },
      '.card-content p:first-of-type': {
        flex: {
          md: 1.3,
          lg: 1.3,
          sm: 1.3,
          xs: 1
        }
      },
      '.card-content p:last-child': {
        color: isDark ? 'text.light' : 'text.primary',
        display: 'flex',
        alignItems: 'center',
        textAlign: {
          md: 'left',
          lg: 'left',
          sm: 'left',
          xs: 'center'
        },
        flex: 1
      },
      '.card-content p:last-child span:first-of-type': {
        fontWeight: '600',
        paddingRight: '3px',
        fontSize: {
          md: '48px',
          lg: '48px',
          sm: '41px',
          xs: '41px'
        },
        lineHeight: '44px'
      },
      '.card-content p:last-child span:last-child': {
        fontFamily: ASPENDENTAL_FONTS.h3.fontFamily,
        fontSize: {
          md: '64px',
          lg: '64px',
          sm: '41px',
          xs: '41px'
        },
        fontWeight: '600',
        lineHeight: '44px'
      }
    }
  }, React.createElement("div", {
    className: "card-content"
  }, React.createElement(TAGTypography, {
    variant: "h2",
    color: isDark ? 'text.light' : 'primary',
    sx: {
      textAlign: {
        md: 'right',
        lg: 'right',
        sm: 'right',
        xs: 'center'
      }
    }
  }, title), React.createElement("p", {
    className: "price"
  }, React.createElement("span", null, "$"), React.createElement("span", null, serviceObj !== null && serviceObj !== void 0 && serviceObj.promotionalPrice ? serviceObj.promotionalPrice : price))), (tc === null || tc === void 0 ? void 0 : tc.tcText) && React.createElement("div", {
    style: {
      marginTop: '20px'
    }
  }, React.createElement(TermsAndConditions, _objectSpread(_objectSpread({}, tc), {}, {
    branding: branding,
    isDark: isDark
  }))))));
};

export default Pricing;